interface ConnectPromptProps {
	message?: string;
}

export function ConnectPrompt({ message = "Connect your wallet to continue" }: ConnectPromptProps) {
	return (
		<div className="connect-prompt">
			<span className="connect-prompt__icon">🔗</span>
			<p className="connect-prompt__message">{message}</p>
		</div>
	);
}
